import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Register Service Worker for PWA and auto-reload when a new version deploys
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      // updateViaCache: 'none' => the browser must bypass its HTTP cache
      // when fetching sw.js. Without this, a redeployed app can serve a
      // stale sw.js from the HTTP cache and the installed PWA keeps running
      // the old service worker (and old bundles) indefinitely.
      .register('/sw.js', { updateViaCache: 'none' })
      .then((registration) => {
        console.log('SW registered:', registration.scope);

        // Immediate update check on every page load / app resume
        registration.update().catch(() => {});

        // Periodic update check (every 15 min while tab is open)
        setInterval(() => registration.update().catch(() => {}), 15 * 60 * 1000);

        // Re-check for updates whenever the installed PWA regains focus.
        // This is critical for standalone PWAs that stay open for days —
        // without it they only check once per load and miss deploys.
        const checkForUpdate = () => registration.update().catch(() => {});
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') checkForUpdate();
        });
        window.addEventListener('focus', checkForUpdate);
        window.addEventListener('online', checkForUpdate);

        // When a new SW is installing, activate it immediately once ready
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (!newWorker) return;
          newWorker.addEventListener('statechange', () => {
            if (
              newWorker.state === 'installed' &&
              navigator.serviceWorker.controller
            ) {
              // New version available — tell it to skip waiting
              newWorker.postMessage({ type: 'SKIP_WAITING' });
            }
          });
        });

        // If a worker was already waiting when we registered (user opened the
        // app during a deploy), trigger activation immediately instead of
        // waiting for the next natural update cycle.
        if (registration.waiting && navigator.serviceWorker.controller) {
          registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        }
      })
      .catch((error) => {
        console.log('SW registration failed:', error);
      });

    // Reload the page once the new SW takes control so users see fresh code.
    // Only reload if there WAS already a controller — on a first-ever visit
    // clients.claim() also fires controllerchange, and we don't want to
    // reload a brand new page needlessly.
    const hadController = !!navigator.serviceWorker.controller;
    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (!hadController) return;
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
    });
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
